export const discounts = [
  {
    label: "10%",
    value: "10",
  },
  {
    label: "15%",
    value: "15",
  },
  {
    label: "20%",
    value: "20",
  },
  {
    label: "25%",
    value: "25",
  },
  {
    label: "30%",
    value: "30",
  },
  {
    label: "50%",
    value: "50",
  },
  {
    label: "75%",
    value: "75",
  },
  {
    label: "100%",
    value: "100",
  },
];
